import { BadRequestError } from '@cian/valuation-utils-component';

import { fetchGetFiltersWeb, IGetFiltersWebRequest } from '../../../repositories/price-estimator/v3/get-filters-web';
import { IThunkContext } from '../../../types/redux';
import { createMapper, TPreciseFiltersResponseMapped, TMappedResponse200 } from './mappers';

export const fetchPreciseFilters = async (
  context: IThunkContext,
  parameters: IGetFiltersWebRequest,
): Promise<TMappedResponse200> => {
  try {
    const res = (await fetchGetFiltersWeb({
      httpApi: context.httpApi,
      parameters,
      mappers: createMapper(parameters),
    })) as TPreciseFiltersResponseMapped;

    if (res instanceof BadRequestError) {
      throw res;
    }

    return res;
  } catch (error) {
    if (error instanceof BadRequestError) {
      context.logger.debug('Ошибка при загрузке точных фильтров', { details: error.printDetails() });
    } else {
      context.logger.error(error, {
        message: 'Ошибка при загрузке точных фильтров',
        parameters: JSON.stringify(parameters),
      });
    }

    throw error;
  }
};
